import React, {useEffect, useState} from 'react'
import { Typography } from '@material-ui/core'

import '../assets/styles.css'

export default function Header({details}) {
  const {icon, title} = details
  const darkMode = JSON.parse(localStorage.getItem("darkMode")) !== null ? JSON.parse(localStorage.getItem("darkMode")) : true
  
  return(
    <div className={`header ${darkMode ? "header-dk" : "header-lt"}`}>
      {icon} <span style={{marginLeft: 5}}>{title.toUpperCase()}</span>
    </div>
  )
}
